import { render, staticRenderFns } from "./IntroSliderComponent.vue?vue&type=template&id=5565813d&"
import script from "./IntroSliderComponent.vue?vue&type=script&lang=ts&"
export * from "./IntroSliderComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports